import { render, staticRenderFns } from "./sitesTable.vue?vue&type=template&id=3cbc060c&scoped=true&"
import script from "./sitesTable.vue?vue&type=script&lang=js&"
export * from "./sitesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbc060c",
  null
  
)

export default component.exports